/**
 * Cache-key prefix the prescriptions list page registers its ListQueryService
 * entries under. The store's mutation effects invalidate this prefix so the
 * list refreshes after a save/update, while embedded cursor lists (which read
 * the NgRx collection) are untouched.
 */
export const PRESCRIPTION_LIST_QUERY_PREFIX = 'prescription|list|';
